<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.mobile"
    :width="width"
    persistent
    :scrollable="scrollable"
  >
    <v-card :disabled="disabled" :loading="loading">
      <v-card-title>
        <slot name="title">
          {{ title }}
          <v-spacer></v-spacer>
          <v-btn @click="close()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </slot>
      </v-card-title>
      <v-card-subtitle v-if="subtitle" v-text="subtitle" />
      <slot></slot>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    actions: Array,
    width: {
      type: Number,
      default: 600
    },
    disabled: Boolean,
    scrollable: Boolean,
    loading: Boolean
  },

  data() {
    return {
      dialog: false
    };
  },

  methods: {
    open() {
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    }
  }
};
</script>
